import React from "react";

import { useSelector } from "react-redux";
import { Container, LinearProgress } from "@mui/material";
import Confirm from "./Confirm";
import { motion } from "framer-motion";
import FileUpload from "./FileUpload";
import PaperSize from "./PaperSize";
import Setting from "./Setting";
import Orientartion from "./Orientartion";
import FileName from "./FileName";
import { useTranslation } from "react-i18next";

function Form() {
  const currentStep = useSelector((state) => state.form.step);
  const { t } = useTranslation();
  const steps = ["1", "2", "3", "4", "5", "6"];
  const process = [
    t("Upload.Documentlist"),
    t("Upload.Size"),
    t("Upload.Setting"),
    t("Upload.Setting"),
    t("Upload.Name"),
    t("Upload.End"),
  ];

  // Define the fade-in animation
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <Container
      sx={{
        paddingTop: "1.25rem",
        px: 0,
        pb: { xs: '7.5rem', sm: '7.5rem' }, // Add enough bottom padding for nav + StepNavigation
      }}
    >
      {currentStep !== 0 && (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <span style={{ fontWeight: 500 }}>
              {process[currentStep]}
            </span>
           
          </div>
          <LinearProgress
            variant="determinate"
            value={((currentStep) / (steps.length - 1)) * 100}
            sx={{ mb: "1.2rem", height: 8, borderRadius: 2 }}
          />
        </>
      )}

      <motion.div initial="hidden" animate="visible" variants={fadeIn}>
        {currentStep === 0 && <FileUpload />}
        {currentStep === 1 && <PaperSize />}
        {currentStep === 2 && <Setting />}
        {currentStep === 3 && <Orientartion />}
        {currentStep === 4 && <FileName />}
        {currentStep === 5 && <Confirm />}
      </motion.div>
    </Container>
  );
}

export default Form;
